import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=3c4935c7&scoped=true&"
import script from "./Idle.vue?vue&type=script&lang=js&"
export * from "./Idle.vue?vue&type=script&lang=js&"
import style0 from "./Idle.vue?vue&type=style&index=0&id=3c4935c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4935c7",
  null
  
)

export default component.exports